module.exports = __webpack_public_path__ + "static/zola.4826e43f.png";


//////////////////
// WEBPACK FOOTER
// ./public/static/zola.png
// module id = 461
// module chunks = 168707334958949